import React from 'react';
import PreAnalysisQuestions from '.';
import { useHistory } from 'react-router-dom';
const FeedbackComponent = () => {
    const hist = useHistory();
    // const stateParams = hist.location.state?.params;
    // const parameters = stateParams && new URLSearchParams(stateParams);
    //   const { browserHistory } = useContext(browserHistoryMemoryContext);
    // console.log(browserHistory,"browserHistory");
    console.log(hist.location.pathname, "hist.location.pathname");
    const sessionId = Number(hist.location.pathname.split('/').filter(Boolean).pop());
    console.log(sessionId, "Importantid");
    return (React.createElement("div", null,
        React.createElement(PreAnalysisQuestions, { sessionId: sessionId })));
};
export default FeedbackComponent;
